
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs,
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ql-fill",attrs:{"d":"M15.5 7h-1.639a4.015 4.015 0 001.914-2.975 1.8 1.8 0 00-1.6-1.751A1.922 1.922 0 0012.021 3.7a.5.5 0 10.957.291.917.917 0 011.053-.725.81.81 0 01.744.762c0 1.077-1.164 1.925-1.934 2.486A1.423 1.423 0 0012 7.5a.5.5 0 00.5.5h3a.5.5 0 000-1zM9.651 5.241a1 1 0 00-1.41.108L6 7.964 3.759 5.349a1 1 0 10-1.519 1.3L4.683 9.5l-2.442 2.85a1 1 0 101.519 1.3L6 11.036l2.241 2.614a1 1 0 001.519-1.3L7.317 9.5l2.442-2.849a1 1 0 00-.108-1.41z"}})])
          )
        }
      }
    